import { Squad } from "../../types/squads";

export const acceptSquadInviteModel = (
  response: Squad
): Squad => response;
